<template>
  <div>
    <the-headersider />

    <!-- Toolbar -->
    <base-card class="toolbar">
      <h2 class="title">Payment History</h2>

      <input
        type="search"
        v-model="search"
        class="search"
        placeholder="Search by name, account or reference"
      />
<!-- 
      <router-link to="/receive/payment" class="cta">
        + Receive Payment
      </router-link> -->
    </base-card>

    <!-- Payments Table -->
    <base-card>
      <div class="table-wrapper">
        <table class="table table-bordered fancy-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Acc No</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <!-- <th>Type</th> -->
              <th>Reference</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredPayments.length === 0">
              <td colspan="6" class="empty">
                No payments found
              </td>
            </tr>

            <tr
              v-for="payment in filteredPayments"
              :key="payment.id"
            >
              <td class="name">{{ payment.paid_by }}</td>
              <td>{{ payment.clientId }}</td>

              <td class="amount">
                KES {{ formatAmount(payment.amount) }}
              </td>

              <td>
                {{ new Date(payment.payment_date).toLocaleString("en-GB") }}
              </td>

              <td>
                <!-- <span
                  class="badge"
                  :class="badgeClass(payment.payment_type)"
                >
                  {{ payment.payment_type }}
                </span> -->
              </td>

              <td class="reference">
                {{ payment.payment_reference }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    payments() {
      return this.$store.getters.MpesaPayments;
    },

    filteredPayments() {
      const key = this.search.toLowerCase();

      return this.payments
        .slice()
        .reverse()
        .filter(p =>
          p.paid_by.toLowerCase().includes(key) ||
          p.clientId.toString().includes(key) ||
          (p.payment_reference || "").toLowerCase().includes(key)
        );
    },
  },

  created() {
    this.$store.dispatch("LoadMpesapayments");
  },

  methods: {
    formatAmount(amount) {
      return Number(amount).toLocaleString();
    },

    badgeClass(type) {
      if (!type) return "default";

      const t = type.toLowerCase();
      if (t.includes("mpesa")) return "mpesa";
      if (t.includes("bank")) return "bank";
      if (t.includes("cash")) return "cash";
      return "default";
    },
  },
};
</script>

<style scoped>
/* Toolbar */
.toolbar {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 1rem;
  align-items: center;
}

.title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f2937;
}

.search {
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

/* CTA */
.cta {
  background: #2563eb;
  color: #fff;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
}

.cta:hover {
  background: #1d4ed8;
}

/* Table */
.table-wrapper {
  overflow-x: auto;
}

.fancy-table thead th {
  position: sticky;
  top: 0;
  background: #f9fafb;
  z-index: 1;
}

.name {
  font-weight: 600;
}

.amount {
  font-weight: 700;
  color: #16a34a;
}

.reference {
  font-size: 0.85rem;
  color: #4b5563;
}

.empty {
  text-align: center;
  padding: 1rem;
  color: #6b7280;
}

/* Badges */
.badge {
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge.mpesa {
  background: #dcfce7;
  color: #166534;
}

.badge.bank {
  background: #e0e7ff;
  color: #3730a3;
}

.badge.cash {
  background: #fef3c7;
  color: #92400e;
}

.badge.default {
  background: #e5e7eb;
  color: #374151;
}
</style>
